import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import type { SaveWorkflowInput } from '../schemas/workflowSchemas';
import { workflowDetailDtoSchema } from '../schemas/workflowSchemas';
import { workflowKeys } from './workflowKeys';

interface SaveWorkflowFullParams {
  workflowId: string;
  body: SaveWorkflowInput;
}

export function useSaveWorkflowFull() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: async ({ workflowId, body }: SaveWorkflowFullParams) => {
      const raw = await apiClient
        .put(`api/v1/t/${tenantId}/workflows/${workflowId}`, { json: body })
        .json();
      return workflowDetailDtoSchema.parse(raw);
    },
    onSuccess: (data) => {
      qc.setQueryData(workflowKeys.detail(data.id), data);
    },
  });
}
